export default __webpack_public_path__ + "images/models/ef46bc9cf3b0b0307c29f2e4d7b26670.glb";